
import { useState } from "react";
import Threat_Modal_Home from "assets/images/Threat_Modal_Home.png";
import CreateModelModal from "./CreateModelModal";

export default function LandingPage() {
  const [showCreateModelModal, setShowCreateModelModal] = useState(false);

  const handleStartModeling = () => {
    setShowCreateModelModal(true);
  };

  return (
    <div className="relative text-white overflow-hidden h-100" style={{ fontFamily: "Inter" }}>
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={Threat_Modal_Home}
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
        {/* Color Overlay */}
        <div className="absolute inset-0" style={{ background: "linear-gradient(81deg, #677CE7 44.75%, rgba(118, 77, 164, 0.20) 102.47%)" }} />
      </div>

      {/* Content Wrapper */}
      <div className="relative z-10 h-full flex flex-col justify-center px-14 py-10">

        {/* Hero Section */}
        <div className="max-w-xl space-y-4">
          <h2 style={{ color: "#FFF", fontFamily: "Inter", fontSize: 52, fontStyle: "italic", fontWeight: 700, lineHeight: 1.15 }}>
            Welcome to<br />Threat Modeling
          </h2>

          <p className="text-sm text-white/80 leading-relaxed max-w-md" style={{ fontFamily: "Inter", fontWeight: 400 }}>
         Our threat modeling application is a proactive tool that enables you to identify, assess, and address 
potential security risks within your applications, systems, or processes.
         <ul className="list-disc list-inside">
           <li>Uncover possible attack scenarios</li>
           <li>Pinpoint vulnerabilities</li>
           <li>Prioritize appropriate solutions</li>
         </ul>
          </p>

          {/* Card */}
          <div className="mt-4 rounded-2xl p-7 shadow-lg" style={{ background: "rgba(255, 255, 255, 0.90)", maxWidth: 580 }}>
            <h1 className="text-xl bg-gradient-to-r from-[#677CE6] to-[#764EA5] bg-clip-text text-transparent mb-2" style={{ fontFamily: "Inter", fontWeight: 700 }}>
              Create a Threat Model
            </h1>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
            Begin by uploading a diagram of your current architecture below.
            </p>

            {/* Buttons */}
            <div className="flex items-center gap-4">
              <button
                type="button"
                onClick={handleStartModeling}
                className="bg-gradient-to-r from-teal-500 to-green-500 hover:shadow-md px-8 py-2.5 rounded-full font-semibold text-white text-sm transition duration-300"
              >
                Start Modeling
              </button>

             {/*  <span className="text-gray-400 text-sm font-medium">or</span>

              <button
                type="button"
                className="px-6 py-2.5 rounded-full text-sm font-semibold transition duration-300 hover:bg-purple-50"
                style={{ border: "1px solid #8A5CF5", color: "#8A5CF5" }}
              >
                Upload previous model
              </button> */}
            </div>
          </div>
        </div>
      </div>

      <CreateModelModal
        open={showCreateModelModal}
        onClose={() => setShowCreateModelModal(false)}
      />
    </div>
  );
}
